import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ProductCategoriesActions, ProductCategoriesEpics, ProductCategoriesFacade } from './+state';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [ProductCategoriesActions, ProductCategoriesFacade, ProductCategoriesEpics]
})
export class ProductCategoriesModule {}
